import WidgetView from '../widget-view'
import InitiativeChartConfig from './initiative-chart-config'
import _ from 'lodash'
import Initiative from 'scoreboard/initiatives/initiative'
import moment from 'moment'
import globals from 'scoreboard/components/globals'
import calendars from 'scoreboard/components/calendars'
import HistoricalGraph from 'scoreboard/initiatives/overview/historical-graph'
import template from './initiative-chart-view.hbs'

var InitiativeChartView = WidgetView.extend({
	className: 'widget initiative-chart-widget',
	resizable: true,
	configClass: InitiativeChartConfig,

	render: function () {
		WidgetView.prototype.render.apply(this, arguments)

		var initData = _.cloneDeep(this.model.data.initiatives(this.model.properties.get('initiativeId')))

		if (initData == null) {
			return
		}

		// Only show data points that are on or before the current period's end date
		let period = calendars.periodsById[this.model.options.getPeriodId()]
		var periodEndDate = moment(period.end)
		function dateFilter (point) {
			return moment(point.date).isSameOrBefore(periodEndDate)
		}

		initData.percentCompletePoints = _.filter(initData.percentCompletePoints, dateFilter)
		initData.actualCostOfWorkPerformed = _.filter(initData.actualCostOfWorkPerformed, dateFilter)

		if (this.$('.content').length === 0) {
			this.$el.append(template({ label: initData.label }))
		}

		this.$el.toggleClass('has-title', this.model.properties.get('showLabel'))

		// If we have a proper EVM chart, we'll always have budgetedCostForWorkScheduled data points (the Goal series)
		var noData = !initData.budgetedCostForWorkScheduled || initData.budgetedCostForWorkScheduled.length === 0
		this.$('.no-data-message').toggleClass('is-not-displayed', !noData)
		this.$('.historical-graph-container').toggleClass('is-not-displayed', noData)

		// Need to adjust .historical-graph-container height to account for visibility of the title
		// Note: using jQuery's outerHeight() instead of something like getBoundingClientRect(), because
		// we specifically **don't** want to take dashboard scaling into account
		let titleHeight = this.getTitleHeight()
		this.$('.historical-graph-container')
			.height(`calc(100% - ${titleHeight}px)`)

		if (!noData) {
			if (this.graph) {
				this.graph.model.clear()
				this.graph.model.set(initData)
				this.graph.resize({
					width: this.model.wob.get('width'),
					height: this.model.wob.get('height') - titleHeight
				})
			} else {
				this.graph = new HistoricalGraph({
					el: this.$('.historical-graph-container'),
					model: new Initiative(initData),
					width: this.model.wob.get('width'),
					height: this.model.wob.get('height') - titleHeight,
					legend: true // dashboard widgets always show the legend
				}).render()

				this.container.on('resized', () => {
					this.graph.resize({
						width: this.model.wob.get('width'),
						height: this.model.wob.get('height') - this.getTitleHeight()
					})
				})
			}
		}

		this.readyForDisplayAndExport()

		return this
	},

	getTitleHeight: function () {
		return this.model.properties.get('showLabel') ? this.$('.title-text').outerHeight() : 0
	},

	remove: function () {
		WidgetView.prototype.remove.apply(this, arguments)
		_.invokeMap([this.graph], 'remove')
	}
})

export default InitiativeChartView

InitiativeChartView.__filename__ = 'dashboards/widgets/initiative-chart/initiative-chart-view.js'
